import { create } from 'zustand';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

export interface ToastPayload {
  id: number;
  variant: ToastVariant;
  title: string;
  message?: string;
  /** Override the default 4s auto-dismiss. 0 = sticky. */
  duration?: number;
}

interface ToastStore {
  /** Max 1 toast at a time per spec rule 8 — new toast replaces the current. */
  current: ToastPayload | null;
  show: (t: Omit<ToastPayload, 'id'>) => number;
  dismiss: () => void;
}

let seq = 0;

export const useToastStore = create<ToastStore>((set) => ({
  current: null,
  show: (t) => {
    const id = ++seq;
    set({ current: { ...t, id } });
    return id;
  },
  dismiss: () => set({ current: null }),
}));
